import type {
    PublishPagePropertyOnboardingContextFieldsV1,
    PublishPagePropertyOnboardingContextIdsV1,
} from "@agoda/analytics-messages-definition-property-onboarding/contexts.split";
import {
    AckTermsConditionsElementPropertyOnboardingManifestV1,
    GstIdElementPropertyOnboardingManifestV1,
    ListYourPropertyBackElementPropertyOnboardingManifestV1,
    ListYourPropertyNextElementPropertyOnboardingManifestV1,
    ListYourPropertyStepperElementPropertyOnboardingManifestV1,
    LocalLawsRegulationsElementPropertyOnboardingManifestV1,
    PermanentAccountNumberElementPropertyOnboardingManifestV1,
    PrivacyPolicyElementPropertyOnboardingManifestV1,
    SaveAndExitElementPropertyOnboardingManifestV1,
    TermsConditionsElementPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/elements";
import {
    PublishPagePropertyOnboardingContextManifestV1,
    WebListYourPropertyPublishVisitEventPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/publish-page";
import { BaseContextFieldsMapping, GetAttributeSafe } from "../../functions/appContext";
import { defineBinder } from "../../functions/defineBinder";

export const publishBinder = defineBinder(({ webAnalytics, action: { click, reveal } }) => {
    webAnalytics.pageContext<PublishPagePropertyOnboardingContextIdsV1, PublishPagePropertyOnboardingContextFieldsV1>(
        PublishPagePropertyOnboardingContextManifestV1.ids,
        {
            auth_user_id: BaseContextFieldsMapping.auth_user_id,
            member_id: BaseContextFieldsMapping.member_id,
            property_id: BaseContextFieldsMapping.property_id,
            is_internal_user: BaseContextFieldsMapping.is_internal_user,
        },
    );

    webAnalytics.observe(WebListYourPropertyPublishVisitEventPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click], ListYourPropertyNextElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ListYourPropertyBackElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ListYourPropertyStepperElementPropertyOnboardingManifestV1.ids, {
        action_element_value: (element: HTMLElement) => GetAttributeSafe(element, "step-name"),
    });
    webAnalytics.observeElement([click], SaveAndExitElementPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click], AckTermsConditionsElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], TermsConditionsElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], PrivacyPolicyElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], LocalLawsRegulationsElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], PermanentAccountNumberElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click, reveal], GstIdElementPropertyOnboardingManifestV1.ids, {});
});
